module.exports = __webpack_public_path__ + "img/top.40c3b76d.png";